export default __webpack_public_path__ + "fonts/dxi1orhcpsqm3vp6mxoatdqqynqkv_9plp7mupa0s4g-webfont.woff";